import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { query } from '@angular/animations';
import { now } from '@amcharts/amcharts4/.internal/core/utils/Time';

@Injectable({
  providedIn: 'root'
})
export class ElasitcService {

  HOST = environment.apiUrl;
  advancequery: string="";
  sorting: string=""; 

  // http options used for making API calls
  private httpOptions: any;
  credentials: string ="";
  constructor(private http: HttpClient) {
    var user = 'vswaroop';
    var password = 'vSw@r00P123';
    this.httpOptions = {
      headers: new HttpHeaders().set('Authorization', `Basic ` + btoa(user + ':' + password))
    };
   }

  getIndices(){    
    return this.http.get(this._getHost("_cat/indices?format=json"),this.httpOptions)
  }

  getIndicesWithFields(): any {
    return this.http.get(this._getHost("_mapping/"),this.httpOptions)
  }

  escapeRegExp(string){
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  } 

  replaceAll(str, term, replacement) {
    return str.replace(new RegExp(this.escapeRegExp(term), 'g'), replacement);
  }

  clean(name: string, removables: any[]): string{
    for(let r of removables){
      name = this.replaceAll(name, r, " ");
    }
    return name;
  }

  __cleanKeywords(keywords): string{
    keywords = keywords.split("*").join("");
    return (keywords === "@all" ? "*": (keywords.length > 0 ? keywords.toString().trim() +"*" : ""));
  }
  
  __cleanAdvanceSearch(advancesearch): string{    
    //console.log(advancesearch);
    this.advancequery='';
   if(advancesearch.find(x=>x.name==='allwords'))
   {
      this.advancequery= "(" + advancesearch.find(x=>x.name==='allwords').value + ")";
   }   
   if(advancesearch.find(x=>x.name==='exactphrase'))
   {
      this.advancequery += (this.advancequery.length>0 ? "" : "") + '+('+ advancesearch.find(x=>x.name==='exactphrase').value + ')';
   }
   if(advancesearch.find(x=>x.name==='anywords'))
   {
    this.advancequery += (this.advancequery.length>0 ? "" : "") +  '|(' + advancesearch.find(x=>x.name==='anywords').value + ')';
   }
   if(advancesearch.find(x=>x.name==='nonewords'))
   {
    this.advancequery += (this.advancequery.length>0 ? "" : "") + '-(' +  advancesearch.find(x=>x.name==='nonewords').value + ')' ;
   }   
   //console.log(this.advancequery);
   if(this.advancequery==='')
   {
    this.advancequery="*";
   }
   return this.advancequery;
   // return (keywords === "@all" ? "*": (keywords.length > 0 ? keywords +"*" : ""));
  }

  getHits(keywords: string, index: any, page: number, pageSize: number, sortOrder: string, facets: any[], filters: any[],advancesearch:any[],sortvalue:string) {        
    var aggs: any = {};
    var must_nots: any[] = [];
    for(let ind of environment.excludeIndices){
      must_nots.push({
        "term" : { "_index" : ind }
      });
    }
    
    for(let f of facets){           
      if(["text", "geo_shape", "binary", "date"].indexOf(f.type) === -1){
        if(f.type === "date"){
          aggs[f.name] = {
              "date_histogram" : {
                "field" : f.name,
                "interval" : "year",
                "min_doc_count": 1
              },
              "aggs": {
                "top_five": {
                  "top_hits": {
                    "size": 5
                  }
                }
              }
          }
        } else {
          var fVal = filters.find(x => x.name === f.name);
         // console.log(fVal);         
          var subAggs: any = {};
          subAggs[f.name] = {
            "terms": { "field" : f.name, "size": (f.size && f.size > 1 ? f.size: 10) },
            "meta": {
              "selections": fVal ? fVal.values: []
            }
          }          
          var aggBoolFilter: any = { "must": [], "should": [], "must_not": must_nots };
          for(let flt of filters.filter(x => x.name !== f.name)){
            for(let fltVal of flt.values){
              var fltObj: any = {};
              fltObj[flt.name] = fltVal;
              var aggFilterTerm = {
                "term": fltObj
              };
              if(flt.values.length > 1)
              aggBoolFilter['should'].push(aggFilterTerm);
              else
              aggBoolFilter['must'].push(aggFilterTerm);
            }
          }
          aggs[f.name] = {
            "filter":{ 
            	"bool": aggBoolFilter
            },
            "aggs": subAggs
          }
        }        
      }
    }
    var post_filters: any = { "must": [], "must_not": must_nots };

    for(let pf of filters){
      var terms = [];
      for(let val of pf.values){
        var filter = {};
        filter[pf.name] = val.toString();
        var trm = {
          "term": filter
        };
        if(pf.values.length === 0)
          post_filters['must'].push(trm);
        else
        terms.push(trm);
      }
      if (terms.length > 0){
        post_filters['must'].push({
          "bool": {
              "should": terms
          }
        });
      }
    }    
    
    if(index.name=="medical_records"){
      this.sorting=JSON.parse('{ "'+ sortvalue +'": { "order": "' + sortOrder + '" } }');
      //console.log(this.sorting);
    }
    else{
      this.sorting=JSON.parse('{ "_score": { "order": "' + sortOrder + '" } }');
    }
    
    if(advancesearch.length===0)
    {
        var query: any = {
          "query":{
            "simple_query_string":{
              "analyze_wildcard": true,
              "all_fields": true,
              "query": this.__cleanKeywords(keywords),
              //"analyzer": "standard",
              // "fields":[
              //   "file.filename^3"
              // ],
              //"minimum_should_match":"20%",
              "default_operator": "or"
              //"default_field": "content",
            }
          },
          "from": ((page -1) * pageSize),
          "size": pageSize,     
          //  "suggest": {
          //    "mytermsuggester": {
          //        "text": this.__cleanKeywords(keywords),
          //        "term": {
          //            "field": "content"
          //        }
          //    }
          //  },   
          "sort":[
            this.sorting
          ],
          // "_source": [
          //   "adherence",
          //   "gender"
          // ],
          "aggs": aggs,
          "post_filter": { "bool": post_filters}
        };  
    } 
    else if(advancesearch.length>0)
    {                  
      //var condition;  
      var condition = []; 
      if(advancesearch.find(x=>x.name==='advanceradio').value==="anytime")
      {
        //condition = []; 
      }
      else if(advancesearch.find(x=>x.name==='advanceradio').value==="inthelastno")
      {
        var lastno=advancesearch.find(x=>x.name==="lastno").value;
        var daysyear=advancesearch.find(x=>x.name==="daysyear").value; 
        var lasttype; 
        if(daysyear=='Days'){lasttype='d/d';}
        
        else {lasttype='/M'; }

        condition.push(JSON.parse('{"range" :{"file.created" : {"lt" : "now-'+lastno+lasttype+'"}}}'));  
      }
      else if(advancesearch.find(x=>x.name==='advanceradio').value==="between"){
        var  btwfrom =advancesearch.find(x=>x.name==="betweenfrom").value;
        var  btwto =advancesearch.find(x=>x.name==="betweento").value;         
        condition.push(JSON.parse('{"range" :{"file.created" : {"gte" : "'+ btwfrom +'" ,"lte" : "'+ btwto +'"}}}'));      
      } 
        var query: any = {
          "query":{
            "bool" : {
              "must" : {             
                "simple_query_string":{                  
                  "all_fields": true,
                  "query": this.__cleanAdvanceSearch(advancesearch),                 
                  "default_operator": "and"                        
                  }                            
               },
               "should":condition,
               "minimum_should_match" : condition.length>0?1:0
               ,"boost" : 1.0
              }
            },
          "from": ((page -1) * pageSize),
          "size": pageSize,
          // "suggest": {
          //   "mytermsuggester": {
          //       "text": this.advancequery,
          //       "term": {
          //           "field": "message"
          //       }
          //   }
          // }, 
          "sort":[
            this.sorting
          ],         
          "aggs": aggs,
          "post_filter": { "bool": post_filters}
        };                      
    }
    console.log(query);    
    return this.http.post(this._getHost((index && index.name.length > 0 ? (index.name + "/") : "") + "_search"), query,this.httpOptions);
  }

  freezeIndex(name){
    return this.http.post(this._getHost(name+"/_freeze"),{},this.httpOptions);
  }
  unfreezeIndex(name){
    return this.http.post(this._getHost(name+"/_unfreeze"),{},this.httpOptions);
  }
  RefreshIndex(name){
    return this.http.post(this._getHost(name+"/_refresh"),{},this.httpOptions);
  }
  _getHost(path: string){
    console.log(this.HOST + path);
    return this.HOST + path;
  }  
}
